import React, { FC } from "react";
import { NavigationSidebar } from "src/components/NavigationSidebar";
import { SCREEN_BREAKPOINTS } from "src/constants/screenBreakpoints";
import { IUserProfileCard } from "src/@types/users";
import { ProfileCard } from "../ProfileCard";
import { NAVIGATION_SIDEBAR_ITEMS } from "./constants";

interface Props {
  userProfileCard?: IUserProfileCard;
  idWithSlug?: string;
}

export const ProfileSidebar: FC<Props> = ({ userProfileCard, idWithSlug }) => (
  <div className="flex flex-col gap-5 gl:max-w-73.75 w-full">
    <ProfileCard {...userProfileCard} />
    <NavigationSidebar
      screenBreakpoint={SCREEN_BREAKPOINTS.GL}
      items={NAVIGATION_SIDEBAR_ITEMS(idWithSlug, userProfileCard?.host?.role)}
      showLogoutButton={false}
    />
  </div>
);
